import { combineEpics } from "redux-observable";
import { epicGetServerPersistence } from "./epics/epicGetServerPersistence";
import { epicRemoveServerPersistenceKeys } from "./epics/epicRemoveServerPersistenceKeys";
import { epicSetDefaultLeagueInfoKeys } from "./epics/epicSetDefaultLeagueInfoKeys";
import { epicSetPreviousCoopLevel } from "./epics/epicSetPreviousCoopLevel";
import { epicSetServerPersistence } from "./epics/epicSetServerPersistence";
export var epicServerPersistence = combineEpics(epicGetServerPersistence, epicSetDefaultLeagueInfoKeys, epicSetPreviousCoopLevel, epicSetServerPersistence, epicRemoveServerPersistenceKeys);



//////////////////
// WEBPACK FOOTER
// ./src/features/server-persistence/epicServerPersistence.ts
// module id = 2325
// module chunks = 3